export const IPOMASTERBANK_DATA = "IPOMASTERBANK_DATA";
export const IPOMASTERBANK_ERROR_DATA = "IPOMASTERBANK_ERROR_DATA";
export const IPOMASTERBANK_HIDE_ERROR_DATA = "IPOMASTERBANK_HIDE_ERROR_DATA";
export const IPOMASTERBANK_START_LOADER = "IPOMASTERBANK_START_LOADER";
export const IPOMASTERBANK_STOP_LOADER = "IPOMASTERBANK_STOP_LOADER";
